// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__3AXB4","socialIcon":"Social_socialIcon__2Bx4I"};